export default __webpack_public_path__ + "static/media/once_off.8b95eba2.svg";